export const UNINITIALIZED = 'UNINITIALIZED';

// SMS
export const REGISTER_SMS = 'REGISTER_SMS';
export const VERIFY_SMS = 'VERIFY_SMS';
export const VERIFICATION_SUCCESSFUL = 'VERIFICATION_SUCCESSFUL';